import { deepValue } from '@corratech/pylot-utils'
import { formatPrice } from '@corratech/pylot-seo'
import { CartItemInterface } from '@pylot-data/pylotschema'

export const getCartItemPrice = (
    item: CartItemInterface,
    pricePath = ['prices', 'row_total', 'value']
): string => {
    const rowTotal: number | false = deepValue(item, pricePath, false)
    const quantity: number = deepValue(item, ['quantity'], 1)
    const price =
        rowTotal !== false
            ? rowTotal / quantity
            : Number(deepValue(item, ['prices', 'price', 'value'], 0))
    return formatPrice(price)
}
